// extracted by mini-css-extract-plugin
export default {"container":"services_container__ecPA0","quoteSection":"services_quoteSection__4u2rV"};